import { render } from "./textMore.vue?vue&type=template&id=f5a502b6&scoped=true"
import script from "./textMore.vue?vue&type=script&lang=js"
export * from "./textMore.vue?vue&type=script&lang=js"

import "./textMore.vue?vue&type=style&index=0&id=f5a502b6&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5a502b6"]])

export default __exports__